<template>
    <div class="white-bg key-item">

        <div class="key-item-img">
            <img :src="getKeyImg" alt="">
        </div>

        <div class="key-item-content">
            <strong>{{dataInfo.bindName}}</strong>
            <div>
                <img :src="getBatteryImg" alt="">
                <div>{{getTime}}</div>
            </div>
            <div class="key-item-progress">
                <div :style="{width: getProgress, backgroundColor: getProgressColor}"></div>
            </div>
        </div>

        <div class="key-item-option" v-if="dataInfo.leaseID">
            <img :src="getShareImg" alt="" @click="gotoShare">
            <img :src="getListImg" alt="" @click="gotoList">
        </div>
        <div class="key-item-option" v-else>
            <img src="../../../../assets/tmp.png" alt="">
        </div>

    </div>
</template>

<script>
    import wx from "weixin-js-sdk";

    export default {
        name: "KeyItem",

        props: {
            dataInfo: {}
        },

        methods: {

            getProgressNum() {
                if (this.dataInfo.authStart && this.dataInfo.authEnd) {
                    return ((new Date().getTime()/1000 - this.dataInfo.authStart)
                        / (this.dataInfo.authEnd - this.dataInfo.authStart)) * 100;
                }
                return 0;
            },

            //分享列表
            gotoList() {
                let vue = this;
                if (this.dataInfo.secondAuthEnabled) {
                    // 微信小程序
                    wx.miniProgram.getEnv(function() {
                        wx.miniProgram.navigateTo({
                            url: "/pages/mkey/listusers?"
                                + "leaseID=" + vue.dataInfo.leaseID
                                + "&bindName=" + encodeURI(vue.dataInfo.bindName)
                                 + "&devID=" + vue.dataInfo.devID
                                 + "&bindID=" + vue.dataInfo.bindID
                                   + "&orgID=" + vue.dataInfo.orgID
                        });
                    });
                }
            },

            //分享
            gotoShare() {
                let vue = this;
                // if (this.dataInfo.secondAuthEnabled) {
                    // 微信小程序 
                    console.log('123:',vue.dataInfo.orgID)
                    wx.miniProgram.getEnv(function() {
                        wx.miniProgram.navigateTo({
                            url: "/pages/mkey/addvisitor?"
                                + "leaseID=" + vue.dataInfo.leaseID   
                                + "&bindName=" + encodeURI(vue.dataInfo.bindName)
                                + "&authEnd=" + vue.dataInfo.authEnd 
                                + "&devID=" + vue.dataInfo.devID
                                 + "&bindID=" + vue.dataInfo.bindID
                                  + "&orgID=" + vue.dataInfo.orgID
                        });
                    })
                // }
            }
        },

        computed: {

            getBatteryImg () {
                if (this.dataInfo.batteryLevel <= 20) {
                    return require("../../../../assets/key/battery-1.png");
                }
                else if (this.dataInfo.batteryLevel <= 40) {
                    return require("../../../../assets/key/battery-2.png");
                }
                else if (this.dataInfo.batteryLevel <= 60) {
                    return require("../../../../assets/key/battery-3.png");
                }
                else if (this.dataInfo.batteryLevel <= 80) {
                    return require("../../../../assets/key/battery-4.png");
                }
                else {
                    return require("../../../../assets/key/battery-5.png");
                }
            },

            getProgress() {
                return this.getProgressNum() + "%";
            },

            getProgressColor() {
                if (this.getProgressNum() <= 50) {
                    return "#99D2BB";
                }
                else if (this.getProgressNum() <= 80) {
                    return "#F5A173";
                }
                else {
                    return "#EB5E5E";
                }
            },

            getKeyImg() {
                if (this.getProgressNum() <= 50) {
                    return require("../../../../assets/key/key-normal.png");
                }
                else if (this.getProgressNum() <= 80) {
                    return require("../../../../assets/key/key-warm.png");
                }
                else {
                    return require("../../../../assets/key/key-error.png");
                }
            },

            getTime() {
                if (this.dataInfo.authEnd == 0) {
                    return ''
                }
                let endTime = new Date(this.dataInfo.authEnd * 1000);
                return endTime.getFullYear() + "-"
                    + (endTime.getMonth() + 1) + "-"
                    + endTime.getDate();
            },

            getShareImg() {
                if (this.dataInfo.secondAuthEnabled) {
                    return require("../../../../assets/key/share-yes.png");
                }
                else {
                    return require("../../../../assets/key/share-no.png");
                }
            },

            getListImg() {
                if (this.dataInfo.secondAuthEnabled) {
                    return require("../../../../assets/key/list-yes.png");
                }
                else {
                    return require("../../../../assets/key/list-no.png");
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../pay/page";

    .key-item {
        align-items: center;
        display: flex;
        border-radius: 10px;
        width: 100%;
        .key-item-img {
            width: 20%;
            min-width: 20%;
            img {
                width: 45px;
            }
        }
        .key-item-content {
            box-sizing: border-box;
            padding-right: 10px;
            width: 80%;
            min-width: 60%;
            text-align: left;
            strong {
                color: $fontColor-3;
            }
            >div {
                font-size: 14px;
                margin-top: 10px;
                justify-content: space-between;
                align-items: center;
                color: $fontColor-9;
                display: flex;
            }
            img {
                height: 15px;
            }
            .key-item-progress {
                border-radius: 50px;
                width: 100%;
                height: 5px;
                background: $bgColor;
                div {
                    border-radius: 50px;
                    height: 5px;
                    background: red;
                }
            }
        }

        .key-item-option {
            justify-content: space-between;
            display: flex;
            flex-direction: column;
            img {
                margin: 5px;
                width: 30px;
            }
        }
    }
</style>
